import axios from "axios";

export function getScoreList(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Scoring/getlist", config);
}

export function updateScoringEvaluation(data) {
  return axios.post(
    process.env.VUE_APP_API_URL + "Scoring/scoringevaluation",
    data
  );
}

export function postSingleScoringEvaluation(data) {
  return axios.post(
    process.env.VUE_APP_API_URL + "Scoring/ScoreAdd",
    data
  );
}

export function postScore(data) {
  const config = {
    params: data,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Scoring/add", config);
}
